module.exports = __webpack_public_path__ + "35d2e87a4fc078a3929a0320c34a9af4.pdf";